import access from './access'
import ticket from './ticket'
import users from './users'
import core from './core'
import orders from './orders'
import orderevents from './orderevents'

var routes = [].concat(
  core,
  orders,
  orderevents,
  access,
  ticket,
  users
)
module.exports = routes



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/index.js